<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [verifyRequiredValidator]="verifyRequiredValidator" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="OK()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" (closeButtonActionEmt)="closeModal()" [(isBusy)]="isBusy"
    [modalHelpIndex]="modalHelpIndex" [(isBusyMessage)]="isBusyMessage" [modalClass]="modalClass"
    [modalHasVariableHeight]="true">
    <res-name-description [isDescriptionHidden]="isDescriptionHidden" [customLabelWidth]="85"
        [automationId]="modalAutomationId" [validateName]="true" [validateNameRequest]="validateNameRequest">
    </res-name-description>
    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
            <label for="pattern" requiredAsterisk [isRequired]="keyFileOperationType !== 'Edit'">Type:
            </label>
        </div>
        <div class="modal-row-column-max">
            <ul class="inline-select">
                <li>
                    <label for="key-file-type-lotus"
                        [ngClass]="{'active': keyFileTypeSelected === 'LOTUS_NOTES', 'disabled': keyFileOperationType === 'Edit'}"
                        [attr.data-automation-id]="modalAutomationId + '-type-lotus-notes-button'">
                        <input type="radio" name="key-file-type" id="key-file-type-lotus"
                            [disabled]="keyFileOperationType === 'Edit'" [(ngModel)]="keyFileTypeSelected"
                            value="LOTUS_NOTES" /> Lotus Notes (.id)
                    </label>
                </li>
                <li>
                    <label for="key-file-type-bitlocker"
                        [ngClass]="{'active': keyFileTypeSelected === 'BIT_LOCKER', 'disabled': keyFileOperationType === 'Edit'}"
                        [attr.data-automation-id]="modalAutomationId + '-type-bitlocker-button'">
                        <input type="radio" name="key-file-type" id="key-file-type-bitlocker"
                            [disabled]="keyFileOperationType === 'Edit'" [(ngModel)]="keyFileTypeSelected"
                            value="BIT_LOCKER" /> MS BitLocker (.txt)
                    </label>
                </li>
            </ul>
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
            <label requiredAsterisk [isRequired]="keyFileOperationType !== 'Edit'">Key File:
            </label>
        </div>
        <div class="modal-row-column-max" [hidden]="keyFileTypeSelected != 'LOTUS_NOTES'">
            <input type="file" class="file-input" (change)="onAccept($event)" #lotusFileUpload accept=".ID,.id">
            <div class="file-upload">
                <input type="text" [disabled]="keyFileOperationType === 'Edit'" [ngModel]="lotusNotesFile?.name"
                    title="{{lotusNotesFile?.name}}"
                    [ngStyle]="{'padding-right' :  keyFileOperationType === 'Edit' ? '5px' : '30px'}"
                    [attr.data-automation-id]="'key-file-settings-lotus-notes-file-name-input'"
                    class="input-field-text" />
                <button type="button" [attr.data-automation-id]="'key-file-settings-lotus-notes-file-delete-button'"
                    *ngIf="lotusNotesFile?.name && keyFileOperationType !== 'Edit'" title="Clear selected files"
                    class="btn btn-secondary btn-action" (click)="onRemove($event)">
                    <i class="fas fa-trash"></i>
                </button>
                <button class="secondary-button btn-file"
                    [attr.data-automation-id]="'key-file-settings-lotus-notes-file-browse-button'"
                    (click)="lotusFileUpload.click()" [disabled]="keyFileOperationType === 'Edit'">Browse ...</button>
            </div>
        </div>
        <div class="modal-row-column-max" [hidden]="keyFileTypeSelected != 'BIT_LOCKER'">
            <input type="file" class="file-input" (change)="onAccept($event)" #bitlockerFileUpload accept=".txt,.TXT">
            <div class="file-upload">
                <input type="text" [disabled]="keyFileOperationType === 'Edit'" [ngModel]="bitLockerFile?.name"
                    title="{{bitLockerFile?.name}}"
                    [ngStyle]="{'padding-right' :  keyFileOperationType === 'Edit' ? '5px' : '30px'}"
                    [attr.data-automation-id]="'key-file-settings-bitlocker-file-name-input'"
                    class="input-field-text" />
                <button type="button" [attr.data-automation-id]="'key-file-settings-bitlocker-file-delete-button'"
                    *ngIf="bitLockerFile?.name && keyFileOperationType !== 'Edit'" title="Clear selected files"
                    class="btn btn-secondary btn-action" (click)="onRemove($event)">
                    <i class="fas fa-trash"></i>
                </button>
                <button class="secondary-button btn-file"
                    [attr.data-automation-id]="'key-file-settings-bitlocker-file-browse-button'"
                    (click)="bitlockerFileUpload.click()" [disabled]="keyFileOperationType === 'Edit'">Browse
                    ...</button>
            </div>
        </div>
    </div>
    <div class="modal-row" [hidden]="keyFileTypeSelected != 'LOTUS_NOTES'">
        <div class="modal-row-column-auto group-label">
            <label for="password" [isRequired]="keyFileOperationType !== 'Edit'">Password:
            </label>
        </div>
        <div class="modal-row-column-max password">
            <input type="password" class="password-column-width" [disabled]="keyFileOperationType === 'Edit'"
                [(ngModel)]="lotusNotesPassword" name="lotusNotesPassword"
                data-automation-id="key-file-settings-lotus-notes-password-input">
        </div>
    </div>
    <div class="bottom-spacer"></div>
</res-base-modal>